import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { DatePicker } from 'react-materialize';
import Loading from '../generalComponets/Loading';
import Functions from '../../api/Functions';
import { Redirect } from 'react-router-dom';
import { dateToMMDDYYYY, dateToYYYYMMDD } from '../../utils/DateUtil';

function TriviaEntries(props) {
  const [date, setDate] = useState(null);
  const [day, setDay] = useState('');
  const [userTriviaResults, setUserTriviaResults] = useState([]);
  const [results, setResults] = useState({});
  const [showLoading, setLoading] = useState(false);
  const { auth } = props;

  if (!auth.uid) return <Redirect to="/signin" />;

  const getUserTriviaResult = () => {
    if (date != null && day.length > 0) {
      setLoading(true);
      Functions.getUserTriviaResultByDay(day)
        .then((results) => {
          console.log('userTriviaResutls', results.data);
          setUserTriviaResults(results.data);
        })
        .catch(() => {
          setUserTriviaResults([]);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const generateEntries = () => {
    if (date != null && day.length > 0) {
      setLoading(true);
      createTriviaEntries();
    } 
  };

  const createTriviaEntries = () => {
    setResults({});
    Functions.manualCreateTriviaEntries(day)
      .then((results) => {
        console.log('results', results.data);
        setResults(results.data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e.message);
        setResults({});
        setLoading(false);
      });
  };

  const renderEntriesId = () => (
    <div>
      {results && results.entries ? results.entries.map((e, index) => (
        <div key={index} className="card">
          <div className="card-content">
            <p>Entry Id: {e}</p>
          </div>
        </div>
      )) : <div />}
    </div>
  );

  const renderUserTriviaResults = () => (
    <div>
      {userTriviaResults.map((u) => (
        <div key={u.id} className="card">
          <div className="card-content">
            <p>Id: {u.id}</p>
            <p>User Id: {u.userId}</p>
            <p>Country: {u.countryCode}</p>
            <p>Timezone: {u.timezone}</p>
            <p>Day: {u.day}</p>
          </div>
        </div>
      ))}
    </div>
  );

  const fieldValue = ({ field, value }) => {
    return (
      <React.Fragment>
        <b>{field}</b>: {value}<br />
      </React.Fragment>
    )
  }

  const selectedDate = () => (
    <div className="row">
      <div className="col">
        {fieldValue({ field: "Date Selected", value: (date != null ? dateToMMDDYYYY(date) : null) })}
        {fieldValue({ field: "Day Formatted", value: (date != null ? dateToYYYYMMDD(date) : null) })}
      </div>
    </div>
  );

    const cardGenerate = ({ title, actionText, actionClick }) => {
    return (

      <div className="card">
        <div className="card-content">
          <span className="card-title">{title}</span>

          <DatePicker
            format='mmm dd, yyyy'
            onChange={(value) => {
              const date = new Date(value);
              setDay(dateToYYYYMMDD(date));
              setDate(date.toString());
            }}
          />
          <div style={{ clear: "both" }}></div>
          {selectedDate()}
          < br />
        </div>

        <div className="card-action">
          <button className="btn" onClick={(e) => actionClick()}>
            {actionText}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <div className="title-section">Create Trivia Entries</div>

      {showLoading ? <Loading /> : <div />}

      <div className="row">
        <div className="col s12 m6">
          {cardGenerate({
            title: "Select Date to create entries",
            actionText: "Generate Entries",
            actionClick: () => {
              generateEntries();
            }
          })}
        </div>
        <div className="col s12 m6">
          {cardGenerate({
            title: "Select Date to get User Trivia Results",
            actionText: "Get User Trivia Result",
            actionClick: () => {
              getUserTriviaResult();
            }
          })}
        </div>
      </div>

      <div className="row">
        <div className="col s12 m6">
          {renderEntriesId()}
        </div>
        <div className="col s12 m6">
          {renderUserTriviaResults()}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([]), connect(mapStateToProps))(TriviaEntries);
